// extracted by mini-css-extract-plugin
export default {"content":"Article_content__jYVoU","page":"Article_page__1C2ar"};